import {
  DASHBOARD_POSICAO_VIEWS_CHANGED,
  DASHBOARD_POSICAO_VIEW_SELECTED,
  DASHBOARD_POSICAO_DATES_CHANGED,
  DASHBOARD_POSICAO_DATE_SELECTED,
  DASHBOARD_POSICAO_CURRENT_KEY_CHANGED,
  DASHBOARD_POSICAO_REQUEST_STARTED,
  DASHBOARD_POSICAO_REQUEST_SUCCEEDED,
  DASHBOARD_POSICAO_REQUEST_FAILED,
  DASHBOARD_POSICAO_CACHE_INVALIDATED
} from '../../const/actionsType';

export function acDashboardPosicaoViewsChanged(pViews) {
  return {
    type: DASHBOARD_POSICAO_VIEWS_CHANGED,
    payload: pViews
  };
}

export function acDashboardPosicaoViewSelected(pViewId) {
  return {
    type: DASHBOARD_POSICAO_VIEW_SELECTED,
    payload: pViewId
  };
}

export function acDashboardPosicaoDatesChanged(pPayload) {
  return {
    type: DASHBOARD_POSICAO_DATES_CHANGED,
    payload: pPayload
  };
}

export function acDashboardPosicaoDateSelected(pPayload) {
  return {
    type: DASHBOARD_POSICAO_DATE_SELECTED,
    payload: pPayload
  };
}

export function acDashboardPosicaoCurrentKeyChanged(pCurrentKey) {
  return {
    type: DASHBOARD_POSICAO_CURRENT_KEY_CHANGED,
    payload: pCurrentKey
  };
}

export function acDashboardPosicaoRequestStarted(pPayload) {
  return {
    type: DASHBOARD_POSICAO_REQUEST_STARTED,
    payload: pPayload
  };
}

export function acDashboardPosicaoRequestSucceeded(pPayload) {
  return {
    type: DASHBOARD_POSICAO_REQUEST_SUCCEEDED,
    payload: pPayload
  };
}

export function acDashboardPosicaoRequestFailed(pPayload) {
  return {
    type: DASHBOARD_POSICAO_REQUEST_FAILED,
    payload: pPayload
  };
}

export function acDashboardPosicaoCacheInvalidated(pCacheKey = null) {
  return {
    type: DASHBOARD_POSICAO_CACHE_INVALIDATED,
    payload: pCacheKey
  };
}
